<template>
  <div>
    <section class="section-header-info middle-content">
      <div class="container big-container">
        <div class="row text-center">
          <div class="col-sm-12">
            <h3>Driver Jobs Inquiry</h3>
            <div class="table-legend">
              <ul>
                <li><i class="ic-flight-icon"></i>Airport Transfer</li>
                <li><i class="ic-time"></i>Hourly Booking</li>
              </ul>
            </div>
            <div class="data-row --blue25">
              <strong>{{ time }}</strong>
            </div>
            <div class="form-group mt-20">
              <div
                class="btn-group btn-group-toggle mb-25"
                data-toggle="buttons"
              >
                <button
                  type="button"
                  class="btn btn-default"
                  :class="{ 'btn-active': period === 'all' }"
                  @click="changePeriods('all')"
                >
                  All
                </button>
                <button
                  type="button"
                  class="btn btn-default"
                  :class="{ 'btn-active': period === 'today' }"
                  @click="changePeriods('today')"
                >
                  Today
                </button>
                <button
                  type="button"
                  class="btn btn-default"
                  :class="{ 'btn-active': period === 'tomorrow' }"
                  @click="changePeriods('tomorrow')"
                >
                  Tomorrow
                </button>
                <button
                  type="button"
                  class="btn btn-default"
                  :class="{ 'btn-active': period === 'next' }"
                  @click="changePeriods('next')"
                >
                  Next Day
                </button>
                <button
                  type="button"
                  class="btn btn-default btn-selectDate"
                  :class="{ 'btn-active': period === 'range' }"
                >
                  <VueCtkDateTimePicker
                    id="jobBrowserDateRange"
                    name="jobBrowserDateRange"
                    v-model="jobBrowserDateRange"
                    color="#025BC5"
                    format="YYYY-MM-DD"
                    formatted="MMM DD"
                    range
                    no-shortcuts
                    label="Select Date"
                    no-header
                    overlay
                    no-button-now
                    button-color="#FFB733"
                    no-clear-button
                    @is-shown="showPicker()"
                    @is-hidden="hidePicker()"
                    @validate="searchRange()"
                  />
                </button>
              </div>
            </div>
          </div>
        </div>
        <div class="row">
          <div class="col-sm-6">
            <div class="dataTables_filter">
              <i class="ic-search"></i>
              <input
                type="search"
                class="form-control"
                v-model="table.keyword"
                @keyup="onKeyupKeyword()"
                placeholder="Search Reservation Code"
              />
            </div>
          </div>
          <div class="col-sm-6">
            <div class="dataTables_length pull-right">
              <label>
                <select
                  class="form-control v-select"
                  v-model="table.pageSize"
                  @change="onChangePageSize()"
                >
                  <option
                    v-for="item in table.pageSizes"
                    :value="item"
                    :key="item"
                  >
                    {{ item }}
                  </option>
                </select>
                Entries</label
              >
            </div>
          </div>
        </div>
        <div class="row">
          <div class="col-sm-12">
            <ul class="nav nav-tabs tabs-inquiry sticky">
              <li class="active">
                <a
                  data-toggle="tab"
                  href="#job-all"
                  @click="changeProgress('all')"
                >
                  <span class="qty-jobs">{{ totalAllJobs }}</span> All
                </a>
              </li>
              <li>
                <a
                  data-toggle="tab"
                  href="#job-open"
                  @click="changeProgress('open')"
                >
                  <span class="qty-jobs">{{ totalJobsOpen }}</span> Open
                </a>
              </li>
              <li>
                <a
                  data-toggle="tab"
                  href="#job-run"
                  @click="changeProgress('run')"
                >
                  <span class="qty-jobs">{{ totalJobsRun }}</span> Run
                </a>
              </li>
              <li>
                <a
                  data-toggle="tab"
                  href="#job-under-review"
                  @click="changeProgress('underreview')"
                >
                  <span class="qty-jobs">{{ totalJobsUnderReview }}</span> Under
                  Review
                </a>
              </li>
              <li class="hidden">
                <a
                  data-toggle="tab"
                  href="#job-rescue"
                  @click="changeProgress('rescueoperation')"
                >
                  <span class="qty-jobs">{{ totalJobsRescued }}</span> Rescue
                </a>
              </li>
              <li>
                <a
                  data-toggle="tab"
                  href="#job-done"
                  @click="changeProgress('done')"
                >
                  <span class="qty-jobs">{{ totalJobsDone }}</span> Done
                </a>
              </li>
              <li class="hidden">
                <a
                  data-toggle="tab"
                  href="#job-close"
                  @click="changeProgress('close')"
                >
                  <span class="qty-jobs">{{ totalJobsClose }}</span> Closed
                </a>
              </li>
            </ul>
            <div class="tab-content">
              <div id="job-all" class="tab-pane fade in active">
                <div class="table-responsive table-manage">
                  <table class="table table-hover">
                    <thead>
                      <tr>
                        <th class="text-center">Type</th>
                        <th>Code &amp; Driver</th>
                        <th class="text-center">Status</th>
                        <th>Passenger</th>
                        <th>Vehicle</th>
                        <th style="min-width: 130px">Pick-Up</th>
                        <th style="text-align: left">Drop-Off</th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr
                        class="detail-row"
                        v-for="item in items"
                        :key="item.reservationId"
                      >
                        <td class="text-center">
                          <strong>
                            <i
                              v-if="
                                isAirportTransfer(item.serviceType) &&
                                item.isPickUpAirport
                              "
                              class="ic-flight-icon"
                            ></i>
                            <i
                              v-else-if="
                                isAirportTransfer(item.serviceType) &&
                                item.isDropOffAirport
                              "
                              class="ic-flight-departure-icon"
                            ></i>
                            <i
                              class="ic-car-alt"
                              v-else-if="
                                isAirportTransfer(item.serviceType) &&
                                !item.isPickUpAirport &&
                                !item.isDropOffAirport
                              "
                            >
                              <svg
                                xmlns="http://www.w3.org/2000/svg"
                                width="32"
                                height="32"
                                viewBox="0 0 1200 1200"
                              >
                                <path
                                  fill="currentColor"
                                  d="m214.662 100.752l-75.97 316.401H0v91.456h47.573v590.639h136.569v-96.685h831.716v96.685h136.496V508.609H1200v-91.456h-138.692l-75.971-316.401H214.662zm40.474 61.52h689.713l61.187 254.887H193.934l61.186-254.887h.016zm-168.048 423.7l190.44 70.329v91.384l-190.44-70.329v-91.384zm1025.73 0v91.384l-190.362 70.329v-91.456l190.362-70.257zM415.833 825.036h368.193v91.384H415.833v-91.384z"
                                />
                              </svg>
                            </i>
                            <i v-else class="ic-time"></i>
                          </strong>
                        </td>
                        <td>
                          <strong>{{ item.code }}</strong>
                          <span class="new-line">
                            {{ item.providerName }}
                          </span>
                          <span class="new-line">
                            ({{ item.driverName }})
                          </span>
                        </td>
                        <td class="pos-rel text-center">
                          <span
                            :class="{
                              'sts_job-open': item.progress === 'Open',
                              'sts_job-run': item.progress === 'Run',
                              'sts_job-done': item.progress === 'Done',
                              'sts_job-closed': item.progress === 'Close',
                              'sts_job-aborted': item.progress === 'Abort',
                              'sts_job-rescue_operation':
                                item.progress === 'RescueOperation',
                            }"
                          ></span>
                          <template v-if="item.workflowControl">
                            <span
                              :class="
                                item.workflowControl.indicator === 1
                                  ? 'green-job mt-5'
                                  : item.workflowControl.indicator === 2
                                  ? 'yellow-job mt-5'
                                  : item.workflowControl.indicator === 3
                                  ? 'red-job mt-5'
                                  : 'last_state d-flex justify-center items-center gap-5'
                              "
                            >
                              <i class="ic-checklist"></i>
                              <span v-if="item.progress === 'RescueOperation'">
                                {{
                                  shortenString(
                                    item.lastState,
                                    "Rescue Operation "
                                  )
                                }}
                              </span>
                              <span class="no-wrap" v-else>
                                {{
                                  item.workflowControl.lastStateDescription
                                }}</span
                              >
                            </span>
                          </template>
                          <template v-else>
                            <span
                              class="last_state d-flex justify-center items-center gap-5"
                            >
                              <i class="ic-checklist"></i>
                              <span v-if="item.progress === 'RescueOperation'">
                                {{
                                  shortenString(
                                    item.lastState,
                                    "Rescue Operation "
                                  )
                                }}
                              </span>
                              <span class="no-wrap" v-else>
                                {{ getLastState(item) }}</span
                              >
                            </span>
                          </template>
                          <div class="row-big-menu" v-if="isAllowToRead">
                            <ul>
                              <li v-if="isAllowToRead">
                                <router-link
                                  :to="`/job/driver/${item.reservationId}`"
                                  target="_blank"
                                  class="sts-warning btn btn-default"
                                >
                                  Details
                                </router-link>
                              </li>
                            </ul>
                          </div>
                        </td>
                        <td>
                          <strong>{{ item.customerName }}</strong>
                          {{
                            userType === "ProviderUser"
                              ? `+${item.customerPhoneCode} ${item.customerPhoneNumber}`
                              : item.companyName
                          }}
                        </td>
                        <td>
                          <strong>{{ item.className }}</strong>
                          <span v-if="item.hasVehicle">
                            <span class="new-line">
                              {{ item.vehicleFactory }} {{ item.vehicleBrand }}
                            </span>
                            <span class="new-line">
                              ({{ item.vehiclePlateNo }})
                            </span>
                          </span>
                        </td>
                        <td>
                          <span v-if="item.isTodayPickUp">
                            <span class="sts-danger">Today</span>,
                            {{ item.pickUpDate.stringDate }}
                            {{ item.pickUpDate.stringShortMonth }}
                            {{ item.pickUpDate.year }}
                          </span>
                          <span v-else>{{
                            item.pickUpDate.stringFullDate
                          }}</span>
                          <strong class="time-utc">
                            {{ item.pickUpDate.stringHour }}:{{
                              item.pickUpDate.stringMinute
                            }}
                            <span class="utc-style"
                              >({{ item.pickUpDate.offsetName }})</span
                            >
                          </strong>
                          <span>{{ item.pickUpLocation }}</span>
                        </td>
                        <td>
                          <span v-if="item.isTodayDropOff">
                            <span class="sts-danger">Today</span>,
                            {{ item.dropOffDate.stringDate }}
                            {{ item.dropOffDate.stringShortMonth }}
                            {{ item.dropOffDate.year }}
                          </span>
                          <span v-else>{{
                            item.dropOffDate.stringFullDate
                          }}</span>
                          <strong class="time-utc">
                            {{ item.dropOffDate.stringHour }}:{{
                              item.dropOffDate.stringMinute
                            }}
                            <span class="utc-style"
                              >({{ item.dropOffDate.offsetName }})</span
                            >
                          </strong>
                          <span>{{ item.dropOffLocation }}</span>
                        </td>
                      </tr>
                    </tbody>
                  </table>
                </div>
              </div>
              <div id="job-under-review" class="tab-pane">
                <div class="table-responsive table-manage">
                  <table class="table table-hover">
                    <thead>
                      <tr>
                        <th>Code &amp; Provider</th>
                        <th class="text-center">Progress &amp; Status</th>
                        <th>Passenger</th>
                        <th>Vehicle</th>
                        <th style="min-width: 130px">Pick-Up</th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr
                        class="detail-row"
                        v-for="item in items"
                        :key="item.reservationId"
                      >
                        <td>
                          <strong>{{ item.code }}</strong>
                          <span class="new-line" v-if="item.hasProvider">
                            {{ item.providerName }}
                          </span>
                          <span class="new-line" v-if="item.hasDriver">
                            ({{ item.driverName }})
                          </span>
                        </td>
                        <td class="text-center">
                          <span
                            :class="{
                              'sts_job-open': item.progress === 'Open',
                              'sts_job-run': item.progress === 'Run',
                              'sts_job-done': item.progress === 'Done',
                              'sts_job-closed': item.progress === 'Close',
                              'sts_job-aborted': item.progress === 'Abort',
                              'sts_job-rescue_operation':
                                item.progress === 'RescueOperation',
                              'sts_job-under-review':
                                item.progress === 'UnderReview',
                            }"
                          ></span>
                          <!-- <span class="last_state">
                            <i class="ic-checklist"></i>
                            <span v-if="item.progress === 'RescueOperation'">
                              {{
                                shortenString(
                                  item.lastState,
                                  "Rescue Operation "
                                )
                              }}
                            </span>
                            <span v-else> {{ getLastState(item) }}</span>
                          </span> -->
                        </td>
                        <td class="pos-rel">
                          <strong>{{ item.customerName }}</strong>
                          {{ item.companyName }}
                        </td>
                        <td>
                          <strong>{{ item.className }}</strong>
                          <span v-if="item.hasVehicle">
                            <span class="new-line">
                              {{ item.vehicleFactory }} {{ item.vehicleBrand }}
                            </span>
                            <span class="new-line">
                              ({{ item.vehiclePlateNo }})
                            </span>
                          </span>
                        </td>
                        <td>
                          <span v-if="item.isTodayPickUp">
                            <span class="sts-danger">Today</span>,
                            {{ item.pickUpDate.stringDate }}
                            {{ item.pickUpDate.stringShortMonth }}
                            {{ item.pickUpDate.year }}
                          </span>
                          <span v-else>{{
                            item.pickUpDate.stringFullDate
                          }}</span>
                          <strong class="time-utc">
                            {{ item.pickUpDate.stringHour }}:{{
                              item.pickUpDate.stringMinute
                            }}
                            <span class="utc-style"
                              >({{ item.pickUpDate.offsetName }})</span
                            >
                          </strong>
                          <span>{{ item.pickUpLocation }}</span>
                        </td>
                      </tr>
                    </tbody>
                  </table>
                </div>
              </div>
              <div id="job-open" class="tab-pane fade">
                <div class="table-responsive table-manage">
                  <table class="table table-hover">
                    <thead>
                      <tr>
                        <th class="text-center">Type</th>
                        <th>Code &amp; Driver</th>
                        <th class="text-center">Status</th>
                        <th>Passenger</th>
                        <th>Vehicle</th>
                        <th style="min-width: 130px">Pick-Up</th>
                        <th style="text-align: left">Drop-Off</th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr
                        class="detail-row"
                        v-for="item in items"
                        :key="item.reservationId"
                      >
                        <td class="text-center">
                          <strong>
                            <i
                              v-if="
                                isAirportTransfer(item.serviceType) &&
                                item.isPickUpAirport
                              "
                              class="ic-flight-icon"
                            ></i>
                            <i
                              v-else-if="
                                isAirportTransfer(item.serviceType) &&
                                item.isDropOffAirport
                              "
                              class="ic-flight-departure-icon"
                            ></i>
                            <i
                              class="ic-car-alt"
                              v-else-if="
                                isAirportTransfer(item.serviceType) &&
                                !item.isPickUpAirport &&
                                !item.isDropOffAirport
                              "
                            >
                              <svg
                                xmlns="http://www.w3.org/2000/svg"
                                width="32"
                                height="32"
                                viewBox="0 0 1200 1200"
                              >
                                <path
                                  fill="currentColor"
                                  d="m214.662 100.752l-75.97 316.401H0v91.456h47.573v590.639h136.569v-96.685h831.716v96.685h136.496V508.609H1200v-91.456h-138.692l-75.971-316.401H214.662zm40.474 61.52h689.713l61.187 254.887H193.934l61.186-254.887h.016zm-168.048 423.7l190.44 70.329v91.384l-190.44-70.329v-91.384zm1025.73 0v91.384l-190.362 70.329v-91.456l190.362-70.257zM415.833 825.036h368.193v91.384H415.833v-91.384z"
                                />
                              </svg>
                            </i>
                            <i v-else class="ic-time"></i>
                          </strong>
                        </td>
                        <td>
                          <strong>{{ item.code }}</strong>
                          <span class="new-line">
                            {{ item.providerName }}
                          </span>
                          <span class="new-line">
                            ({{ item.driverName }})
                          </span>
                        </td>
                        <td class="pos-rel text-center">
                          <template v-if="item.workflowControl">
                            <span
                              :class="
                                item.workflowControl.indicator === 1
                                  ? 'green-job mt-5'
                                  : item.workflowControl.indicator === 2
                                  ? 'yellow-job mt-5'
                                  : item.workflowControl.indicator === 3
                                  ? 'red-job mt-5'
                                  : 'last_state d-flex justify-center items-center gap-5'
                              "
                            >
                              <i class="ic-checklist"></i>
                              <span v-if="item.progress === 'RescueOperation'">
                                {{
                                  shortenString(
                                    item.lastState,
                                    "Rescue Operation "
                                  )
                                }}
                              </span>
                              <span class="no-wrap" v-else>
                                {{
                                  item.workflowControl.lastStateDescription
                                }}</span
                              >
                            </span>
                          </template>
                          <template v-else>
                            <span
                              class="last_state d-flex justify-center items-center gap-5"
                            >
                              <i class="ic-checklist"></i>
                              <span v-if="item.progress === 'RescueOperation'">
                                {{
                                  shortenString(
                                    item.lastState,
                                    "Rescue Operation "
                                  )
                                }}
                              </span>
                              <span class="no-wrap" v-else>
                                {{ getLastState(item) }}</span
                              >
                            </span>
                          </template>
                          <div
                            class="row-big-menu"
                            v-if="
                              ((isAllowToConfirm || isAllowToDecline) &&
                                $helper.isNotExpiredDate(item.utcPickUpDate)) ||
                              isAllowToRead
                            "
                          >
                            <ul>
                              <li
                                v-if="
                                  item.isOwnInventory &&
                                  item.lastState !== 'Driver Confirmed' &&
                                  pickUpDateExpired(item.utcPickUpDate) &&
                                  isAllowToConfirm
                                "
                              >
                                <button
                                  class="btn btn-default"
                                  type="button"
                                  @click="openConfirmationDialog(item)"
                                >
                                  <span>Confirm</span>
                                </button>
                              </li>
                              <li
                                v-if="
                                  item.isOwnInventory &&
                                  isAllowToDecline &&
                                  $helper.isNotExpiredDate(item.utcPickUpDate)
                                "
                              >
                                <button
                                  class="btn btn-default sts-danger"
                                  type="button"
                                  @click="openDeclineDialog(item)"
                                >
                                  <span>Decline</span>
                                </button>
                              </li>
                              <li v-if="isAllowToRead">
                                <router-link
                                  :to="`/job/driver/${item.reservationId}`"
                                  target="_blank"
                                  class="sts-warning btn btn-default"
                                >
                                  Details
                                </router-link>
                              </li>
                            </ul>
                          </div>
                        </td>
                        <td>
                          <strong>{{ item.customerName }}</strong>
                          {{
                            userType === "ProviderUser"
                              ? `+${item.customerPhoneCode} ${item.customerPhoneNumber}`
                              : item.companyName
                          }}
                        </td>
                        <td>
                          <strong>{{ item.className }}</strong>
                          <span v-if="item.hasVehicle">
                            <span class="new-line">
                              {{ item.vehicleFactory }} {{ item.vehicleBrand }}
                            </span>
                            <span class="new-line">
                              ({{ item.vehiclePlateNo }})
                            </span>
                          </span>
                        </td>
                        <td>
                          <span v-if="item.isTodayPickUp">
                            <span class="sts-danger">Today</span>,
                            {{ item.pickUpDate.stringDate }}
                            {{ item.pickUpDate.stringShortMonth }}
                            {{ item.pickUpDate.year }}
                          </span>
                          <span v-else>{{
                            item.pickUpDate.stringFullDate
                          }}</span>
                          <strong class="time-utc">
                            {{ item.pickUpDate.stringHour }}:{{
                              item.pickUpDate.stringMinute
                            }}
                            <span class="utc-style"
                              >({{ item.pickUpDate.offsetName }})</span
                            >
                          </strong>
                          <span>{{ item.pickUpLocation }}</span>
                        </td>
                        <td>
                          <span v-if="item.isTodayDropOff">
                            <span class="sts-danger">Today</span>,
                            {{ item.dropOffDate.stringDate }}
                            {{ item.dropOffDate.stringShortMonth }}
                            {{ item.dropOffDate.year }}
                          </span>
                          <span v-else>{{
                            item.dropOffDate.stringFullDate
                          }}</span>
                          <strong class="time-utc">
                            {{ item.dropOffDate.stringHour }}:{{
                              item.dropOffDate.stringMinute
                            }}
                            <span class="utc-style"
                              >({{ item.dropOffDate.offsetName }})</span
                            >
                          </strong>
                          <span>{{ item.dropOffLocation }}</span>
                        </td>
                      </tr>
                    </tbody>
                  </table>
                </div>
              </div>
              <div id="job-run" class="tab-pane fade">
                <div class="table-responsive table-manage">
                  <table class="table table-hover">
                    <thead>
                      <tr>
                        <th class="text-center">Type</th>
                        <th>Code &amp; Driver</th>
                        <th class="text-center">Status</th>
                        <th>Passenger</th>
                        <th>Vehicle</th>
                        <th style="min-width: 130px">Pick-Up</th>
                        <th style="text-align: left">Drop-Off</th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr
                        class="detail-row"
                        v-for="item in items"
                        :key="item.reservationId"
                      >
                        <td class="text-center">
                          <strong>
                            <i
                              v-if="
                                isAirportTransfer(item.serviceType) &&
                                item.isPickUpAirport
                              "
                              class="ic-flight-icon"
                            ></i>
                            <i
                              v-else-if="
                                isAirportTransfer(item.serviceType) &&
                                item.isDropOffAirport
                              "
                              class="ic-flight-departure-icon"
                            ></i>
                            <i
                              class="ic-car-alt"
                              v-else-if="
                                isAirportTransfer(item.serviceType) &&
                                !item.isPickUpAirport &&
                                !item.isDropOffAirport
                              "
                            >
                              <svg
                                xmlns="http://www.w3.org/2000/svg"
                                width="32"
                                height="32"
                                viewBox="0 0 1200 1200"
                              >
                                <path
                                  fill="currentColor"
                                  d="m214.662 100.752l-75.97 316.401H0v91.456h47.573v590.639h136.569v-96.685h831.716v96.685h136.496V508.609H1200v-91.456h-138.692l-75.971-316.401H214.662zm40.474 61.52h689.713l61.187 254.887H193.934l61.186-254.887h.016zm-168.048 423.7l190.44 70.329v91.384l-190.44-70.329v-91.384zm1025.73 0v91.384l-190.362 70.329v-91.456l190.362-70.257zM415.833 825.036h368.193v91.384H415.833v-91.384z"
                                />
                              </svg>
                            </i>
                            <i v-else class="ic-time"></i>
                          </strong>
                        </td>
                        <td>
                          <strong>{{ item.code }}</strong>
                          <span class="new-line">
                            {{ item.providerName }}
                          </span>
                          <span class="new-line">
                            ({{ item.driverName }})
                          </span>
                        </td>
                        <td class="pos-rel text-center">
                          <template v-if="item.workflowControl">
                            <span
                              :class="
                                item.workflowControl.indicator === 1
                                  ? 'green-job mt-5'
                                  : item.workflowControl.indicator === 2
                                  ? 'yellow-job mt-5'
                                  : item.workflowControl.indicator === 3
                                  ? 'red-job mt-5'
                                  : 'last_state d-flex justify-center items-center gap-5'
                              "
                            >
                              <i class="ic-checklist"></i>
                              <span v-if="item.progress === 'RescueOperation'">
                                {{
                                  shortenString(
                                    item.lastState,
                                    "Rescue Operation "
                                  )
                                }}
                              </span>
                              <span class="no-wrap" v-else>
                                {{
                                  item.workflowControl.lastStateDescription
                                }}</span
                              >
                            </span>
                          </template>
                          <template v-else>
                            <span
                              class="last_state d-flex justify-center items-center gap-5"
                            >
                              <i class="ic-checklist"></i>
                              <span v-if="item.progress === 'RescueOperation'">
                                {{
                                  shortenString(
                                    item.lastState,
                                    "Rescue Operation "
                                  )
                                }}
                              </span>
                              <span class="no-wrap" v-else>
                                {{ getLastState(item) }}</span
                              >
                            </span>
                          </template>
                          <div
                            class="row-big-menu"
                            v-if="
                              (isAllowToConfirm &&
                                $helper.isNotExpiredDate(item.utcPickUpDate)) ||
                              isAllowToRead
                            "
                          >
                            <ul>
                              <!-- <li
                                v-if="
                                  item.isOwnInventory &&
                                  item.lastState !== 'Driver Confirmed' &&
                                  isAllowToConfirm &&
                                  $helper.isNotExpiredDate(item.utcPickUpDate)
                                "
                              >
                                <button
                                  class="btn btn-default"
                                  type="button"
                                  @click="openConfirmationDialog(item)"
                                >
                                  <span>Confirm</span>
                                </button>
                              </li> -->
                              <li v-if="isAllowToRead">
                                <router-link
                                  :to="`/job/driver/${item.reservationId}`"
                                  target="_blank"
                                  class="sts-warning btn btn-default"
                                >
                                  Details
                                </router-link>
                              </li>
                            </ul>
                          </div>
                        </td>
                        <td>
                          <strong>{{ item.customerName }}</strong>
                          {{
                            userType === "ProviderUser"
                              ? `+${item.customerPhoneCode} ${item.customerPhoneNumber}`
                              : item.companyName
                          }}
                        </td>
                        <td>
                          <strong>{{ item.className }}</strong>
                          <span v-if="item.hasVehicle">
                            <span class="new-line">
                              {{ item.vehicleFactory }} {{ item.vehicleBrand }}
                            </span>
                            <span class="new-line">
                              ({{ item.vehiclePlateNo }})
                            </span>
                          </span>
                        </td>
                        <td>
                          <span v-if="item.isTodayPickUp">
                            <span class="sts-danger">Today</span>,
                            {{ item.pickUpDate.stringDate }}
                            {{ item.pickUpDate.stringShortMonth }}
                            {{ item.pickUpDate.year }}
                          </span>
                          <span v-else>{{
                            item.pickUpDate.stringFullDate
                          }}</span>
                          <strong class="time-utc">
                            {{ item.pickUpDate.stringHour }}:{{
                              item.pickUpDate.stringMinute
                            }}
                            <span class="utc-style"
                              >({{ item.pickUpDate.offsetName }})</span
                            >
                          </strong>
                          <span>{{ item.pickUpLocation }}</span>
                        </td>
                        <td>
                          <span v-if="item.isTodayDropOff">
                            <span class="sts-danger">Today</span>,
                            {{ item.dropOffDate.stringDate }}
                            {{ item.dropOffDate.stringShortMonth }}
                            {{ item.dropOffDate.year }}
                          </span>
                          <span v-else>{{
                            item.dropOffDate.stringFullDate
                          }}</span>
                          <strong class="time-utc">
                            {{ item.dropOffDate.stringHour }}:{{
                              item.dropOffDate.stringMinute
                            }}
                            <span class="utc-style"
                              >({{ item.dropOffDate.offsetName }})</span
                            >
                          </strong>
                          <span>{{ item.dropOffLocation }}</span>
                        </td>
                      </tr>
                    </tbody>
                  </table>
                </div>
              </div>
              <div id="job-rescue" class="tab-pane fade">
                <div class="table-responsive table-manage">
                  <table class="table table-hover">
                    <thead>
                      <tr>
                        <th class="text-center">Type</th>
                        <th>Code &amp; Driver</th>
                        <th class="text-center">Status</th>
                        <th>Passenger</th>
                        <th>Vehicle</th>
                        <th style="min-width: 130px">Pick-Up</th>
                        <th style="text-align: left">Drop-Off</th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr
                        class="detail-row"
                        v-for="item in items"
                        :key="item.reservationId"
                      >
                        <td class="text-center">
                          <strong>
                            <i
                              v-if="
                                isAirportTransfer(item.serviceType) &&
                                item.isPickUpAirport
                              "
                              class="ic-flight-icon"
                            ></i>
                            <i
                              v-else-if="
                                isAirportTransfer(item.serviceType) &&
                                item.isDropOffAirport
                              "
                              class="ic-flight-departure-icon"
                            ></i>
                            <i
                              class="ic-car-alt"
                              v-else-if="
                                isAirportTransfer(item.serviceType) &&
                                !item.isPickUpAirport &&
                                !item.isDropOffAirport
                              "
                            >
                              <svg
                                xmlns="http://www.w3.org/2000/svg"
                                width="32"
                                height="32"
                                viewBox="0 0 1200 1200"
                              >
                                <path
                                  fill="currentColor"
                                  d="m214.662 100.752l-75.97 316.401H0v91.456h47.573v590.639h136.569v-96.685h831.716v96.685h136.496V508.609H1200v-91.456h-138.692l-75.971-316.401H214.662zm40.474 61.52h689.713l61.187 254.887H193.934l61.186-254.887h.016zm-168.048 423.7l190.44 70.329v91.384l-190.44-70.329v-91.384zm1025.73 0v91.384l-190.362 70.329v-91.456l190.362-70.257zM415.833 825.036h368.193v91.384H415.833v-91.384z"
                                />
                              </svg>
                            </i>
                            <i v-else class="ic-time"></i>
                          </strong>
                        </td>
                        <td>
                          <strong>{{ item.code }}</strong>
                          <span class="new-line">
                            {{ item.providerName }}
                          </span>
                          <span class="new-line">
                            ({{ item.driverName }})
                          </span>
                        </td>
                        <td class="pos-rel text-center">
                          <template v-if="item.workflowControl">
                            <span
                              :class="
                                item.workflowControl.indicator === 1
                                  ? 'green-job mt-5'
                                  : item.workflowControl.indicator === 2
                                  ? 'yellow-job mt-5'
                                  : item.workflowControl.indicator === 3
                                  ? 'red-job mt-5'
                                  : 'last_state d-flex justify-center items-center gap-5'
                              "
                            >
                              <i class="ic-checklist"></i>
                              <span v-if="item.progress === 'RescueOperation'">
                                {{
                                  shortenString(
                                    item.lastState,
                                    "Rescue Operation "
                                  )
                                }}
                              </span>
                              <span class="no-wrap" v-else>
                                {{
                                  item.workflowControl.lastStateDescription
                                }}</span
                              >
                            </span>
                          </template>
                          <template v-else>
                            <span
                              class="last_state d-flex justify-center items-center gap-5"
                            >
                              <i class="ic-checklist"></i>
                              <span v-if="item.progress === 'RescueOperation'">
                                {{
                                  shortenString(
                                    item.lastState,
                                    "Rescue Operation "
                                  )
                                }}
                              </span>
                              <span class="no-wrap" v-else>
                                {{ getLastState(item) }}</span
                              >
                            </span>
                          </template>
                          <div class="row-big-menu" v-if="isAllowToRead">
                            <ul>
                              <li v-if="isAllowToRead">
                                <router-link
                                  :to="`/job/driver/${item.reservationId}`"
                                  target="_blank"
                                  class="sts-warning btn btn-default"
                                >
                                  Details
                                </router-link>
                              </li>
                            </ul>
                          </div>
                        </td>
                        <td>
                          <strong>{{ item.customerName }}</strong>
                          {{
                            userType === "ProviderUser"
                              ? `+${item.customerPhoneCode} ${item.customerPhoneNumber}`
                              : item.companyName
                          }}
                        </td>
                        <td>
                          <strong>{{ item.className }}</strong>
                          <span v-if="item.hasVehicle">
                            <span class="new-line">
                              {{ item.vehicleFactory }} {{ item.vehicleBrand }}
                            </span>
                            <span class="new-line">
                              ({{ item.vehiclePlateNo }})
                            </span>
                          </span>
                        </td>
                        <td>
                          <span v-if="item.isTodayPickUp">
                            <span class="sts-danger">Today</span>,
                            {{ item.pickUpDate.stringDate }}
                            {{ item.pickUpDate.stringShortMonth }}
                            {{ item.pickUpDate.year }}
                          </span>
                          <span v-else>{{
                            item.pickUpDate.stringFullDate
                          }}</span>
                          <strong class="time-utc">
                            {{ item.pickUpDate.stringHour }}:{{
                              item.pickUpDate.stringMinute
                            }}
                            <span class="utc-style"
                              >({{ item.pickUpDate.offsetName }})</span
                            >
                          </strong>
                          <span>{{ item.pickUpLocation }}</span>
                        </td>
                        <td>
                          <span v-if="item.isTodayDropOff">
                            <span class="sts-danger">Today</span>,
                            {{ item.dropOffDate.stringDate }}
                            {{ item.dropOffDate.stringShortMonth }}
                            {{ item.dropOffDate.year }}
                          </span>
                          <span v-else>{{
                            item.dropOffDate.stringFullDate
                          }}</span>
                          <strong class="time-utc">
                            {{ item.dropOffDate.stringHour }}:{{
                              item.dropOffDate.stringMinute
                            }}
                            <span class="utc-style"
                              >({{ item.dropOffDate.offsetName }})</span
                            >
                          </strong>
                          <span>{{ item.dropOffLocation }}</span>
                        </td>
                      </tr>
                    </tbody>
                  </table>
                </div>
              </div>
              <div id="job-done" class="tab-pane fade">
                <div class="table-responsive table-manage">
                  <table class="table table-hover">
                    <thead>
                      <tr>
                        <th class="text-center">Type</th>
                        <th>Code &amp; Driver</th>
                        <th class="text-center">Status</th>
                        <th>Passenger</th>
                        <th>Vehicle</th>
                        <th style="min-width: 130px">Pick-Up</th>
                        <th style="text-align: left">Drop-Off</th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr
                        class="detail-row"
                        v-for="item in items"
                        :key="item.reservationId"
                      >
                        <td class="text-center">
                          <strong>
                            <i
                              v-if="
                                isAirportTransfer(item.serviceType) &&
                                item.isPickUpAirport
                              "
                              class="ic-flight-icon"
                            ></i>
                            <i
                              v-else-if="
                                isAirportTransfer(item.serviceType) &&
                                item.isDropOffAirport
                              "
                              class="ic-flight-departure-icon"
                            ></i>
                            <i
                              class="ic-car-alt"
                              v-else-if="
                                isAirportTransfer(item.serviceType) &&
                                !item.isPickUpAirport &&
                                !item.isDropOffAirport
                              "
                            >
                              <svg
                                xmlns="http://www.w3.org/2000/svg"
                                width="32"
                                height="32"
                                viewBox="0 0 1200 1200"
                              >
                                <path
                                  fill="currentColor"
                                  d="m214.662 100.752l-75.97 316.401H0v91.456h47.573v590.639h136.569v-96.685h831.716v96.685h136.496V508.609H1200v-91.456h-138.692l-75.971-316.401H214.662zm40.474 61.52h689.713l61.187 254.887H193.934l61.186-254.887h.016zm-168.048 423.7l190.44 70.329v91.384l-190.44-70.329v-91.384zm1025.73 0v91.384l-190.362 70.329v-91.456l190.362-70.257zM415.833 825.036h368.193v91.384H415.833v-91.384z"
                                />
                              </svg>
                            </i>
                            <i v-else class="ic-time"></i>
                          </strong>
                        </td>
                        <td>
                          <strong>{{ item.code }}</strong>
                          <span class="new-line">
                            {{ item.providerName }}
                          </span>
                          <span class="new-line">
                            ({{ item.driverName }})
                          </span>
                        </td>
                        <td class="pos-rel text-center">
                          <template v-if="item.workflowControl">
                            <span
                              :class="
                                item.workflowControl.indicator === 1
                                  ? 'green-job mt-5'
                                  : item.workflowControl.indicator === 2
                                  ? 'yellow-job mt-5'
                                  : item.workflowControl.indicator === 3
                                  ? 'red-job mt-5'
                                  : 'last_state d-flex justify-center items-center gap-5'
                              "
                            >
                              <i class="ic-checklist"></i>
                              <span v-if="item.progress === 'RescueOperation'">
                                {{
                                  shortenString(
                                    item.lastState,
                                    "Rescue Operation "
                                  )
                                }}
                              </span>
                              <span class="no-wrap" v-else>
                                {{
                                  item.workflowControl.lastStateDescription
                                }}</span
                              >
                            </span>
                          </template>
                          <template v-else>
                            <span
                              class="last_state d-flex justify-center items-center gap-5"
                            >
                              <i class="ic-checklist"></i>
                              <span v-if="item.progress === 'RescueOperation'">
                                {{
                                  shortenString(
                                    item.lastState,
                                    "Rescue Operation "
                                  )
                                }}
                              </span>
                              <span class="no-wrap" v-else>
                                {{ getLastState(item) }}</span
                              >
                            </span>
                          </template>
                          <div class="row-big-menu" v-if="isAllowToRead">
                            <ul>
                              <li v-if="isAllowToRead">
                                <router-link
                                  :to="`/job/driver/${item.reservationId}`"
                                  target="_blank"
                                  class="sts-warning btn btn-default"
                                >
                                  Details
                                </router-link>
                              </li>
                            </ul>
                          </div>
                        </td>
                        <td>
                          <strong>{{ item.customerName }}</strong>
                          {{
                            userType === "ProviderUser"
                              ? `+${item.customerPhoneCode} ${item.customerPhoneNumber}`
                              : item.companyName
                          }}
                        </td>
                        <td>
                          <strong>{{ item.className }}</strong>
                          <span v-if="item.hasVehicle">
                            <span class="new-line">
                              {{ item.vehicleFactory }} {{ item.vehicleBrand }}
                            </span>
                            <span class="new-line">
                              ({{ item.vehiclePlateNo }})
                            </span>
                          </span>
                        </td>
                        <td>
                          <span v-if="item.isTodayPickUp">
                            <span class="sts-danger">Today</span>,
                            {{ item.pickUpDate.stringDate }}
                            {{ item.pickUpDate.stringShortMonth }}
                            {{ item.pickUpDate.year }}
                          </span>
                          <span v-else>{{
                            item.pickUpDate.stringFullDate
                          }}</span>
                          <strong class="time-utc">
                            {{ item.pickUpDate.stringHour }}:{{
                              item.pickUpDate.stringMinute
                            }}
                            <span class="utc-style"
                              >({{ item.pickUpDate.offsetName }})</span
                            >
                          </strong>
                          <span>{{ item.pickUpLocation }}</span>
                        </td>
                        <td>
                          <span v-if="item.isTodayDropOff">
                            <span class="sts-danger">Today</span>,
                            {{ item.dropOffDate.stringDate }}
                            {{ item.dropOffDate.stringShortMonth }}
                            {{ item.dropOffDate.year }}
                          </span>
                          <span v-else>{{
                            item.dropOffDate.stringFullDate
                          }}</span>
                          <strong class="time-utc">
                            {{ item.dropOffDate.stringHour }}:{{
                              item.dropOffDate.stringMinute
                            }}
                            <span class="utc-style"
                              >({{ item.dropOffDate.offsetName }})</span
                            >
                          </strong>
                          <span>{{ item.dropOffLocation }}</span>
                        </td>
                      </tr>
                    </tbody>
                  </table>
                </div>
              </div>
              <div id="job-close" class="tab-pane fade">
                <div class="table-responsive table-manage">
                  <table class="table table-hover">
                    <thead>
                      <tr>
                        <th class="text-center">Type</th>
                        <th>Code &amp; Driver</th>
                        <th class="text-center">Status</th>
                        <th>Passenger</th>
                        <th>Vehicle</th>
                        <th style="min-width: 130px">Pick-Up</th>
                        <th style="text-align: left">Drop-Off</th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr
                        class="detail-row"
                        v-for="item in items"
                        :key="item.reservationId"
                      >
                        <td class="text-center">
                          <strong>
                            <i
                              v-if="
                                isAirportTransfer(item.serviceType) &&
                                item.isPickUpAirport
                              "
                              class="ic-flight-icon"
                            ></i>
                            <i
                              v-else-if="
                                isAirportTransfer(item.serviceType) &&
                                item.isDropOffAirport
                              "
                              class="ic-flight-departure-icon"
                            ></i>
                            <i
                              class="ic-car-alt"
                              v-else-if="
                                isAirportTransfer(item.serviceType) &&
                                !item.isPickUpAirport &&
                                !item.isDropOffAirport
                              "
                            >
                              <svg
                                xmlns="http://www.w3.org/2000/svg"
                                width="32"
                                height="32"
                                viewBox="0 0 1200 1200"
                              >
                                <path
                                  fill="currentColor"
                                  d="m214.662 100.752l-75.97 316.401H0v91.456h47.573v590.639h136.569v-96.685h831.716v96.685h136.496V508.609H1200v-91.456h-138.692l-75.971-316.401H214.662zm40.474 61.52h689.713l61.187 254.887H193.934l61.186-254.887h.016zm-168.048 423.7l190.44 70.329v91.384l-190.44-70.329v-91.384zm1025.73 0v91.384l-190.362 70.329v-91.456l190.362-70.257zM415.833 825.036h368.193v91.384H415.833v-91.384z"
                                />
                              </svg>
                            </i>
                            <i v-else class="ic-time"></i>
                          </strong>
                        </td>
                        <td>
                          <strong>{{ item.code }}</strong>
                          <span class="new-line">
                            {{ item.providerName }}
                          </span>
                          <span class="new-line">
                            ({{ item.driverName }})
                          </span>
                        </td>
                        <td class="pos-rel text-center">
                          <template v-if="item.workflowControl">
                            <span
                              :class="
                                item.workflowControl.indicator === 1
                                  ? 'green-job mt-5'
                                  : item.workflowControl.indicator === 2
                                  ? 'yellow-job mt-5'
                                  : item.workflowControl.indicator === 3
                                  ? 'red-job mt-5'
                                  : 'last_state d-flex justify-center items-center gap-5'
                              "
                            >
                              <i class="ic-checklist"></i>
                              <span v-if="item.progress === 'RescueOperation'">
                                {{
                                  shortenString(
                                    item.lastState,
                                    "Rescue Operation "
                                  )
                                }}
                              </span>
                              <span class="no-wrap" v-else>
                                {{
                                  item.workflowControl.lastStateDescription
                                }}</span
                              >
                            </span>
                          </template>
                          <template v-else>
                            <span
                              class="last_state d-flex justify-center items-center gap-5"
                            >
                              <i class="ic-checklist"></i>
                              <span v-if="item.progress === 'RescueOperation'">
                                {{
                                  shortenString(
                                    item.lastState,
                                    "Rescue Operation "
                                  )
                                }}
                              </span>
                              <span class="no-wrap" v-else>
                                {{ getLastState(item) }}</span
                              >
                            </span>
                          </template>
                          <div class="row-big-menu" v-if="isAllowToRead">
                            <ul>
                              <li v-if="isAllowToRead">
                                <router-link
                                  :to="`/job/driver/${item.reservationId}`"
                                  target="_blank"
                                  class="sts-warning btn btn-default"
                                >
                                  Details
                                </router-link>
                              </li>
                            </ul>
                          </div>
                        </td>
                        <td>
                          <strong>{{ item.customerName }}</strong>
                          {{
                            userType === "ProviderUser"
                              ? `+${item.customerPhoneCode} ${item.customerPhoneNumber}`
                              : item.companyName
                          }}
                        </td>
                        <td>
                          <strong>{{ item.className }}</strong>
                          <span v-if="item.hasVehicle">
                            <span class="new-line">
                              {{ item.vehicleFactory }} {{ item.vehicleBrand }}
                            </span>
                            <span class="new-line">
                              ({{ item.vehiclePlateNo }})
                            </span>
                          </span>
                        </td>
                        <td>
                          <span v-if="item.isTodayPickUp">
                            <span class="sts-danger">Today</span>,
                            {{ item.pickUpDate.stringDate }}
                            {{ item.pickUpDate.stringShortMonth }}
                            {{ item.pickUpDate.year }}
                          </span>
                          <span v-else>{{
                            item.pickUpDate.stringFullDate
                          }}</span>
                          <strong class="time-utc">
                            {{ item.pickUpDate.stringHour }}:{{
                              item.pickUpDate.stringMinute
                            }}
                            <span class="utc-style"
                              >({{ item.pickUpDate.offsetName }})</span
                            >
                          </strong>
                          <span>{{ item.pickUpLocation }}</span>
                        </td>
                        <td>
                          <span v-if="item.isTodayDropOff">
                            <span class="sts-danger">Today</span>,
                            {{ item.dropOffDate.stringDate }}
                            {{ item.dropOffDate.stringShortMonth }}
                            {{ item.dropOffDate.year }}
                          </span>
                          <span v-else>{{
                            item.dropOffDate.stringFullDate
                          }}</span>
                          <strong class="time-utc">
                            {{ item.dropOffDate.stringHour }}:{{
                              item.dropOffDate.stringMinute
                            }}
                            <span class="utc-style"
                              >({{ item.dropOffDate.offsetName }})</span
                            >
                          </strong>
                          <span>{{ item.dropOffLocation }}</span>
                        </td>
                      </tr>
                    </tbody>
                  </table>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="row">
          <div class="col-sm-5">
            <div class="dataTables_info --blue25">
              <strong>{{ recordInfo }}</strong>
            </div>
          </div>
          <div class="col-sm-7">
            <nav aria-label="...">
              <paginate
                v-model="table.pageNumber"
                :page-count="table.totalPages"
                :click-handler="onNavigateCallback"
                :prev-text="'Previous'"
                :next-text="'Next'"
                :container-class="'pagination pull-right'"
              >
              </paginate>
            </nav>
          </div>
        </div>
      </div>
    </section>
    <!-- OverrideConfirmDriver -->

    <confirmModal
      :id="'DriverConfirmation'"
      :header="'Confirm'"
      :content="`Are you sure you want confirm this job?`"
      :cancel-label="'Cancel'"
      :submit-label="'Yes, Confirm'"
      :color="'confirm-icon'"
      :icon="'ic-check'"
      @submit="confirmDriver"
    />
    <confirmModal
      :id="'OverrideConfirmDriver'"
      :header="'Potential Job Conflict'"
      :content="`This driver has another assignment that may overlap this job. Are you sure you wish to proceed?`"
      :cancel-label="'No'"
      :submit-label="'Yes'"
      :color="'confirm-icon'"
      :icon="'ic-warning'"
      @submit="confirmDriver(true)"
    />
    <confirmModal
      :id="'DriverDeclineConfirmation'"
      :header="'Decline'"
      :content="`Are you sure you want decline this job?`"
      :cancel-label="'Cancel'"
      :submit-label="'Yes, Decline'"
      :color="'delete-icon'"
      :icon="'ic-close'"
      @submit="declineDriver"
    />

    <!-- Start: BlockUI -->
    <loader :content="msg" :visible="isLoading" />
    <!-- End: BlockUI -->
  </div>
</template>

<script>
import moment from "moment";
import confirmModal from "@/components/shared/ConfirmModal";
import inquiryDriverJobService from "@/services/job/driverJob/inquiryDriverJobService.js";

export default {
  components: {
    confirmModal,
  },
  computed: {
    isAllowToRead: function () {
      return this.allPermissions.includes("Read");
    },
    isAllowToConfirm: function () {
      return this.allPermissions.includes("Confirm");
    },
    isAllowToDecline: function () {
      return this.allPermissions.includes("Decline");
    },
    time: function () {
      const date = new Date();
      switch (this.period) {
        case "tomorrow":
          date.setDate(date.getDate() + 1);
          break;
        case "next":
          date.setDate(date.getDate() + 2);
          break;
      }
      return moment(date).format("dddd, MMMM DD yyyy");
    },
    recordInfo: function () {
      return this.table.totalRecords > 1
        ? `${this.table.totalRecords} Records`
        : `${this.table.totalRecords} Record`;
    },
    isShowTripLog: function () {
      return this.allPermissions.includes("TripLog");
    },
    pickUpDateExpired() {
      return (utcPickUpDate) => {
        if (this.userType === "TenantUser") {
          return true;
        } else {
          return this.$helper.isNotExpiredDate(utcPickUpDate);
        }
      };
    },
  },
  data() {
    return {
      table: {
        keyword: "",
        totalPages: 1,
        totalRecords: 0,
        pageNumber: 1,
        pageSize: 25,
        pageSizes: [25, 50, 100],
      },
      jobBrowserDateRange: null,
      allPermissions: [],
      defaultPageSize: 0,
      // period: "today",
      period: "today",
      progress: "all",
      items: [
        {
          reservationId: "3b460f30-86c9-4798-bf30-f9af5f2ca9da",
          code: "OPS202201177EAFC",
          className: "MPV",
          reservationDate: {
            year: 2022,
            month: 1,
            day: 17,
            hour: 14,
            minute: 6,
            second: 15,
            offsetName: "UTC+07:00",
            stringShortMonth: "Jan",
            stringFullDate: "Mon, 17 Jan 2022",
            stringMonth: "01",
            stringDate: "17",
            stringHour: "14",
            stringMinute: "06",
          },
          originTimezone: "Asia/Jakarta",
          pickUpDate: {
            year: 2022,
            month: 1,
            day: 17,
            hour: 17,
            minute: 0,
            second: 0,
            offsetName: "UTC+07:00",
            stringShortMonth: "Jan",
            stringFullDate: "Mon, 17 Jan 2022",
            stringMonth: "01",
            stringDate: "17",
            stringHour: "17",
            stringMinute: "00",
          },
          dropOffDate: {
            year: 2022,
            month: 1,
            day: 17,
            hour: 17,
            minute: 0,
            second: 0,
            offsetName: "UTC+07:00",
            stringShortMonth: "Jan",
            stringFullDate: "Mon, 17 Jan 2022",
            stringMonth: "01",
            stringDate: "17",
            stringHour: "17",
            stringMinute: "00",
          },
          utcPickUpDate: "2022-01-17T10:00:00+00:00",
          utcDropOffDate: "2022-01-17T10:00:00+00:00",
          pickUpLocation: "Soekarno-Hatta International Airport",
          isPickUpAirport: false,
          dropOffLocation: "Gambir Station",
          isDropOffAirport: false,
          companyName: "Root ARRANGGE SG",
          companyPhoneCode: "62",
          companyPhoneNumber: "21234567",
          customerName: "Mr. Aussie",
          customerPhoneCode: "62",
          customerPhoneNumber: "85372828",
          providerName: "Dot Car Rentals",
          driverName: null,
          vehicleFactory: null,
          vehicleBrand: null,
          vehiclePlateNo: null,
          lastState: "Provider Assigned",
          serviceType: "AirportTransfer",
          progress: "Under Review",
          isSelfDrive: false,
          hasProvider: true,
          hasDriver: false,
          hasVehicle: false,
          isTodayBooking: false,
          isTodayPickUp: false,
          isTodayDropOff: false,
          searchMode: "Hybrid",
          queueProgress: null,
          minutePickUpOffsetTime: 0,
          flightEstimatedArrivalTimes: null,
          flightConfirmedTimes: null,
          driverStandbyTime: null,
        },
        {
          reservationId: "26a30c17-1399-4134-a813-fd6b4ffe3983",
          code: "OPS2022011748C61",
          className: "MPV",
          reservationDate: {
            year: 2022,
            month: 1,
            day: 17,
            hour: 16,
            minute: 50,
            second: 17,
            offsetName: "UTC+07:00",
            stringShortMonth: "Jan",
            stringFullDate: "Mon, 17 Jan 2022",
            stringMonth: "01",
            stringDate: "17",
            stringHour: "16",
            stringMinute: "50",
          },
          originTimezone: "Asia/Jakarta",
          pickUpDate: {
            year: 2022,
            month: 1,
            day: 17,
            hour: 18,
            minute: 0,
            second: 0,
            offsetName: "UTC+07:00",
            stringShortMonth: "Jan",
            stringFullDate: "Mon, 17 Jan 2022",
            stringMonth: "01",
            stringDate: "17",
            stringHour: "18",
            stringMinute: "00",
          },
          dropOffDate: {
            year: 2022,
            month: 1,
            day: 17,
            hour: 18,
            minute: 0,
            second: 0,
            offsetName: "UTC+07:00",
            stringShortMonth: "Jan",
            stringFullDate: "Mon, 17 Jan 2022",
            stringMonth: "01",
            stringDate: "17",
            stringHour: "18",
            stringMinute: "00",
          },
          utcPickUpDate: "2022-01-17T11:00:00+00:00",
          utcDropOffDate: "2022-01-17T11:00:00+00:00",
          pickUpLocation: "Soekarno-Hatta International Airport",
          isPickUpAirport: false,
          dropOffLocation: "Gambir Station",
          isDropOffAirport: false,
          companyName: "Root ARRANGGE SG",
          companyPhoneCode: "62",
          companyPhoneNumber: "21234567",
          customerName: "Mr. Arata",
          customerPhoneCode: "62",
          customerPhoneNumber: "81380558380",
          providerName: "Dot Car Rentals",
          driverName: null,
          vehicleFactory: null,
          vehicleBrand: null,
          vehiclePlateNo: null,
          lastState: "Provider Assigned",
          serviceType: "AirportTransfer",
          progress: "Under Review",
          isSelfDrive: false,
          hasProvider: true,
          hasDriver: false,
          hasVehicle: false,
          isTodayBooking: false,
          isTodayPickUp: false,
          isTodayDropOff: false,
          searchMode: "Hybrid",
          queueProgress: null,
          minutePickUpOffsetTime: 0,
          flightEstimatedArrivalTimes: null,
          flightConfirmedTimes: null,
          driverStandbyTime: null,
        },
        {
          reservationId: "e15e8440-2088-4629-9b6b-328b0ec6e382",
          code: "OPS20220118B52BF",
          className: "MPV",
          reservationDate: {
            year: 2022,
            month: 1,
            day: 18,
            hour: 9,
            minute: 43,
            second: 37,
            offsetName: "UTC+07:00",
            stringShortMonth: "Jan",
            stringFullDate: "Tue, 18 Jan 2022",
            stringMonth: "01",
            stringDate: "18",
            stringHour: "09",
            stringMinute: "43",
          },
          originTimezone: "Asia/Jakarta",
          pickUpDate: {
            year: 2022,
            month: 1,
            day: 18,
            hour: 10,
            minute: 0,
            second: 0,
            offsetName: "UTC+07:00",
            stringShortMonth: "Jan",
            stringFullDate: "Tue, 18 Jan 2022",
            stringMonth: "01",
            stringDate: "18",
            stringHour: "10",
            stringMinute: "00",
          },
          dropOffDate: {
            year: 2022,
            month: 1,
            day: 18,
            hour: 10,
            minute: 0,
            second: 0,
            offsetName: "UTC+07:00",
            stringShortMonth: "Jan",
            stringFullDate: "Tue, 18 Jan 2022",
            stringMonth: "01",
            stringDate: "18",
            stringHour: "10",
            stringMinute: "00",
          },
          utcPickUpDate: "2022-01-18T03:00:00+00:00",
          utcDropOffDate: "2022-01-18T03:00:00+00:00",
          pickUpLocation: "Soekarno-Hatta International Airport",
          isPickUpAirport: false,
          dropOffLocation: "Gambir Station",
          isDropOffAirport: false,
          companyName: "Root ARRANGGE SG",
          companyPhoneCode: "62",
          companyPhoneNumber: "21234567",
          customerName: "Mr. Arya",
          customerPhoneCode: "62",
          customerPhoneNumber: "81380558380",
          providerName: "(CT Dev) NN Provider Test",
          driverName: null,
          vehicleFactory: null,
          vehicleBrand: null,
          vehiclePlateNo: null,
          lastState: "Provider Assigned",
          serviceType: "AirportTransfer",
          progress: "Under Review",
          isSelfDrive: false,
          hasProvider: true,
          hasDriver: false,
          hasVehicle: false,
          isTodayBooking: false,
          isTodayPickUp: false,
          isTodayDropOff: false,
          searchMode: "Hybrid",
          queueProgress: null,
          minutePickUpOffsetTime: 0,
          flightEstimatedArrivalTimes: null,
          flightConfirmedTimes: null,
          driverStandbyTime: null,
        },
        {
          reservationId: "e1a53878-f09f-4ec4-a790-b12864b482fd",
          code: "OPS202201186C655",
          className: "MPV",
          reservationDate: {
            year: 2022,
            month: 1,
            day: 18,
            hour: 8,
            minute: 6,
            second: 58,
            offsetName: "UTC+07:00",
            stringShortMonth: "Jan",
            stringFullDate: "Tue, 18 Jan 2022",
            stringMonth: "01",
            stringDate: "18",
            stringHour: "08",
            stringMinute: "06",
          },
          originTimezone: "Asia/Jakarta",
          pickUpDate: {
            year: 2022,
            month: 1,
            day: 18,
            hour: 10,
            minute: 0,
            second: 0,
            offsetName: "UTC+07:00",
            stringShortMonth: "Jan",
            stringFullDate: "Tue, 18 Jan 2022",
            stringMonth: "01",
            stringDate: "18",
            stringHour: "10",
            stringMinute: "00",
          },
          dropOffDate: {
            year: 2022,
            month: 1,
            day: 18,
            hour: 10,
            minute: 0,
            second: 0,
            offsetName: "UTC+07:00",
            stringShortMonth: "Jan",
            stringFullDate: "Tue, 18 Jan 2022",
            stringMonth: "01",
            stringDate: "18",
            stringHour: "10",
            stringMinute: "00",
          },
          utcPickUpDate: "2022-01-18T03:00:00+00:00",
          utcDropOffDate: "2022-01-18T03:00:00+00:00",
          pickUpLocation: "Soekarno-Hatta International Airport",
          isPickUpAirport: false,
          dropOffLocation: "Gambir Station",
          isDropOffAirport: false,
          companyName: "Root ARRANGGE SG",
          companyPhoneCode: "62",
          companyPhoneNumber: "21234567",
          customerName: "Mr. Arya",
          customerPhoneCode: "62",
          customerPhoneNumber: "81380558380",
          providerName: "(CT Dev) NN Provider Test",
          driverName: null,
          vehicleFactory: null,
          vehicleBrand: null,
          vehiclePlateNo: null,
          lastState: "Provider Assigned",
          serviceType: "AirportTransfer",
          progress: "Under Review",
          isSelfDrive: false,
          hasProvider: true,
          hasDriver: false,
          hasVehicle: false,
          isTodayBooking: false,
          isTodayPickUp: false,
          isTodayDropOff: false,
          searchMode: "Hybrid",
          queueProgress: null,
          minutePickUpOffsetTime: 0,
          flightEstimatedArrivalTimes: null,
          flightConfirmedTimes: null,
          driverStandbyTime: null,
        },
        {
          reservationId: "3ea1db71-0bbc-4a11-bc53-e30571f3887b",
          code: "OPS20220118CEB5D",
          className: "MPV",
          reservationDate: {
            year: 2022,
            month: 1,
            day: 18,
            hour: 10,
            minute: 5,
            second: 39,
            offsetName: "UTC+07:00",
            stringShortMonth: "Jan",
            stringFullDate: "Tue, 18 Jan 2022",
            stringMonth: "01",
            stringDate: "18",
            stringHour: "10",
            stringMinute: "05",
          },
          originTimezone: "Asia/Jakarta",
          pickUpDate: {
            year: 2022,
            month: 1,
            day: 18,
            hour: 11,
            minute: 0,
            second: 0,
            offsetName: "UTC+07:00",
            stringShortMonth: "Jan",
            stringFullDate: "Tue, 18 Jan 2022",
            stringMonth: "01",
            stringDate: "18",
            stringHour: "11",
            stringMinute: "00",
          },
          dropOffDate: {
            year: 2022,
            month: 1,
            day: 18,
            hour: 11,
            minute: 0,
            second: 0,
            offsetName: "UTC+07:00",
            stringShortMonth: "Jan",
            stringFullDate: "Tue, 18 Jan 2022",
            stringMonth: "01",
            stringDate: "18",
            stringHour: "11",
            stringMinute: "00",
          },
          utcPickUpDate: "2022-01-18T04:00:00+00:00",
          utcDropOffDate: "2022-01-18T04:00:00+00:00",
          pickUpLocation: "Soekarno-Hatta International Airport",
          isPickUpAirport: false,
          dropOffLocation: "Gambir Station",
          isDropOffAirport: false,
          companyName: "Root ARRANGGE SG",
          companyPhoneCode: "62",
          companyPhoneNumber: "21234567",
          customerName: "Mr. Arya",
          customerPhoneCode: "62",
          customerPhoneNumber: "81380558380",
          providerName: "(CT Dev) NN Provider Test",
          driverName: null,
          vehicleFactory: null,
          vehicleBrand: null,
          vehiclePlateNo: null,
          lastState: "Provider Assigned",
          serviceType: "AirportTransfer",
          progress: "Under Review",
          isSelfDrive: false,
          hasProvider: true,
          hasDriver: false,
          hasVehicle: false,
          isTodayBooking: false,
          isTodayPickUp: false,
          isTodayDropOff: false,
          searchMode: "Hybrid",
          queueProgress: null,
          minutePickUpOffsetTime: 0,
          flightEstimatedArrivalTimes: null,
          flightConfirmedTimes: null,
          driverStandbyTime: null,
        },
        {
          reservationId: "b97f2458-647c-4674-a428-bbbb8444834d",
          code: "OPS20220118A5670",
          className: "MPV",
          reservationDate: {
            year: 2022,
            month: 1,
            day: 18,
            hour: 10,
            minute: 13,
            second: 54,
            offsetName: "UTC+07:00",
            stringShortMonth: "Jan",
            stringFullDate: "Tue, 18 Jan 2022",
            stringMonth: "01",
            stringDate: "18",
            stringHour: "10",
            stringMinute: "13",
          },
          originTimezone: "Asia/Jakarta",
          pickUpDate: {
            year: 2022,
            month: 1,
            day: 18,
            hour: 11,
            minute: 0,
            second: 0,
            offsetName: "UTC+07:00",
            stringShortMonth: "Jan",
            stringFullDate: "Tue, 18 Jan 2022",
            stringMonth: "01",
            stringDate: "18",
            stringHour: "11",
            stringMinute: "00",
          },
          dropOffDate: {
            year: 2022,
            month: 1,
            day: 18,
            hour: 11,
            minute: 0,
            second: 0,
            offsetName: "UTC+07:00",
            stringShortMonth: "Jan",
            stringFullDate: "Tue, 18 Jan 2022",
            stringMonth: "01",
            stringDate: "18",
            stringHour: "11",
            stringMinute: "00",
          },
          utcPickUpDate: "2022-01-18T04:00:00+00:00",
          utcDropOffDate: "2022-01-18T04:00:00+00:00",
          pickUpLocation: "Soekarno-Hatta International Airport",
          isPickUpAirport: false,
          dropOffLocation: "Gambir Station",
          isDropOffAirport: false,
          companyName: "Root ARRANGGE SG",
          companyPhoneCode: "62",
          companyPhoneNumber: "21234567",
          customerName: "Mr. Arya",
          customerPhoneCode: "62",
          customerPhoneNumber: "81380558380",
          providerName: "(CT Dev) NN Provider Test",
          driverName: null,
          vehicleFactory: null,
          vehicleBrand: null,
          vehiclePlateNo: null,
          lastState: "Provider Assigned",
          serviceType: "AirportTransfer",
          progress: "Under Review",
          isSelfDrive: false,
          hasProvider: true,
          hasDriver: false,
          hasVehicle: false,
          isTodayBooking: false,
          isTodayPickUp: false,
          isTodayDropOff: false,
          searchMode: "Hybrid",
          queueProgress: null,
          minutePickUpOffsetTime: 0,
          flightEstimatedArrivalTimes: null,
          flightConfirmedTimes: null,
          driverStandbyTime: null,
        },
      ],
      totalAllJobs: 0,
      totalJobsOpen: 0,
      totalJobsRun: 0,
      totalJobsUnderReview: 0,
      totalJobsDone: 0,
      totalJobsClose: 0,
      totalJobsAborted: 0,
      totalJobsRescued: 0,
      isLoading: false,
      msg: "Please wait",
      selectedDriverJob: {},
      userType: "Unspecified",
    };
  },
  async created() {
    this.$helper.scrollTop();
    await this.getUserType();
    const publicSettings = await this.$store.dispatch("setting/getAllPublic");
    this.table.pageSize = this.$helper.extractSetting(
      publicSettings,
      "PageSize",
      25
    );
    this.defaultPageSize = this.table.pageSize;

    const profile = await this.$store.dispatch("user/getProfile");
    const permissions = profile.services[this.$route.name];
    if (permissions) {
      this.allPermissions = permissions;
    }

    if (this.isAllowToRead) {
      await Promise.all([
        this.countAll(),
        this.getAll(this.period, this.progress),
      ]);
    }
  },
  updated() {
    this.$helper.collapseMenu("job");
    this.$helper.setNavigationClass("driver-job-browser-link");
    $("#jobBrowserDateRange-input").addClass("borderless-jobBrowserDateRange");
  },
  methods: {
    async onChangePageSize() {
      this.table.pageNumber = 1;
      await this.getAll(this.period, this.progress);
    },
    async onKeyupKeyword() {
      const self = this;
      if (self.timer) {
        clearTimeout(self.timer);
        self.timer = null;
      }
      self.timer = setTimeout(async (_) => {
        self.table.pageNumber = 1;
        await self.getAll(self.period, self.progress);
      }, 500);
    },
    async onNavigateCallback(pageNumber) {
      this.table.pageNumber = pageNumber;
      await this.getAll(this.period, this.progress);
    },
    async getUserType() {
      const profile = await this.$store.dispatch("user/getProfile");
      this.userType = profile.userType;
    },
    isAirportTransfer(serviceType) {
      return serviceType.toLowerCase() === "airporttransfer";
    },
    openConfirmationDialog(item) {
      this.selectedDriverJob = item;
      $("#DriverConfirmation").modal({ backdrop: "static", keyboard: false });
    },
    openDeclineDialog(item) {
      this.selectedDriverJob = item;
      $("#DriverDeclineConfirmation").modal({
        backdrop: "static",
        keyboard: false,
      });
    },
    async changeProgress(progress) {
      this.table.keyword = "";
      this.table.pageNumber = 1;
      this.table.pageSize = this.defaultPageSize;
      this.progress = progress;
      await this.getAll(this.period, this.progress);
    },
    async changePeriods(period) {
      this.period = period;
      await Promise.all([
        this.countAll(),
        this.getAll(this.period, this.progress, true),
      ]);
    },
    async getAll(period, progress, clear = false) {
      if (!this.isAllowToRead) {
        return;
      }
      try {
        if (clear) this.table.pageNumber = 1;
        this.isLoading = true;
        this.items = [];
        this.period = period;
        this.progress = progress;
        let filter = `?page=${this.table.pageNumber}&size=${this.table.pageSize}`;
        if (this.table.keyword !== null && this.table.keyword !== "") {
          filter += `&search=${this.table.keyword}`;
        }
        filter += `&data=${this.progress};0;${this.convertPeriod()}`;
        const response = await inquiryDriverJobService.getAll(filter);
        this.items = response.data;
        this.table.totalPages = response.totalPages;
        this.table.totalRecords = response.totalRecords;
      } catch (error) {
        if (error.errors) {
          for (let index = 0; index < error.errors.length; index++) {
            this.$notification.error(error.errors[index], { title: "Error" });
          }
        }
      } finally {
        this.isLoading = false;
      }
    },
    async countAll() {
      try {
        const response = await inquiryDriverJobService.countAll(
          this.convertPeriod(),
          0
        );
        this.totalAllJobs = response.data.totalAllJobs;
        this.totalJobsOpen = response.data.totalJobsOpen;
        this.totalJobsRun = response.data.totalJobsRun;
        this.totalJobsUnderReview = response.data.totalJobsUnderReview;
        this.totalJobsDone = response.data.totalJobsDone;
        this.totalJobsClose = response.data.totalJobsClose;
        this.totalJobsAborted = response.data.totalJobsAborted;
        this.totalJobsRescued = response.data.totalJobsRescued;
      } catch (error) {
        if (error.errors) {
          for (let index = 0; index < error.errors.length; index++) {
            this.$notification.error(error.errors[index], { title: "Error" });
          }
        }
      }
    },
    async confirmDriver(overrideTimingBlock = false) {
      try {
        this.isLoading = true;

        await inquiryDriverJobService.confirmDriver({
          reservationId: this.selectedDriverJob.reservationId,
          driverId: this.selectedDriverJob.driverId,
          overrideTimingBlock: overrideTimingBlock,
        });

        setTimeout(async () => {
          await Promise.all([
            this.countAll(),
            this.getAll(this.period, this.progress),
          ]);
          this.isLoading = false;
          $(this.$refs.provider_driverjob_modal).modal("hide");
          this.$notification.success("Successfully confirmed.", {
            title: "Success",
          });
        }, 1000);
      } catch (error) {
        if (
          this.userType === "TenantUser" &&
          error.errors[0].includes("JTB001|")
        ) {
          $("#OverrideConfirmDriver").modal({
            backdrop: "static",
            keyboard: false,
          });
        } else {
          if (error.errors) {
            for (let index = 0; index < error.errors.length; index++) {
              this.$notification.error(error.errors[index], { title: "Error" });
            }
          }
        }
        this.isLoading = false;
      }
    },
    async declineDriver() {
      try {
        this.isLoading = true;

        await inquiryDriverJobService.declineDriver({
          reservationId: this.selectedDriverJob.reservationId,
          driverId: this.selectedDriverJob.driverId,
        });

        setTimeout(async () => {
          await Promise.all([
            this.countAll(),
            this.getAll(this.period, this.progress),
          ]);
          this.isLoading = false;
          $(this.$refs.provider_driverjob_modal).modal("hide");
          this.$notification.success("Successfully declined.", {
            title: "Success",
          });
        }, 1000);
      } catch (error) {
        if (error.errors) {
          for (let index = 0; index < error.errors.length; index++) {
            this.$notification.error(error.errors[index], { title: "Error" });
          }
        }
      }
    },
    convertPeriod() {
      let result = "";
      const date = new Date();
      switch (this.period.toLowerCase()) {
        case "all":
          this.jobBrowserDateRange = null;
          result = "all";
          break;
        case "today":
          this.jobBrowserDateRange = null;
          result = `today_${date.getFullYear()}-${
            date.getMonth() + 1
          }-${date.getDate()}`;
          break;
        case "tomorrow":
          this.jobBrowserDateRange = null;
          date.setDate(date.getDate() + 1);
          result = `tomorrow_${date.getFullYear()}-${
            date.getMonth() + 1
          }-${date.getDate()}`;
          break;
        case "next":
          this.jobBrowserDateRange = null;
          date.setDate(date.getDate() + 2);
          result = `next_${date.getFullYear()}-${
            date.getMonth() + 1
          }-${date.getDate()}`;
          break;
        case "range":
          result = `range_${this.jobBrowserDateRange.start}_${this.jobBrowserDateRange.end}`;
          break;
      }
      return result;
    },
    getLastState(item) {
      if (item.hasDriver && item.hasVehicle) {
        return "Driver & Vehicle Assigned";
      } else {
        return item.lastState;
      }
    },
    shortenString(item, textToBeReplaced) {
      return item.replace(textToBeReplaced, "");
    },
    showPicker() {
      $(".tabs-inquiry").removeClass("sticky");
    },
    hidePicker() {
      $(".tabs-inquiry").addClass("sticky");
    },
    async searchRange() {
      if (
        !this.jobBrowserDateRange.start ||
        this.jobBrowserDateRange.start === "" ||
        !this.jobBrowserDateRange.end ||
        this.jobBrowserDateRange.end === ""
      ) {
        alert("Please select a date range.");
        return;
      }
      this.hidePicker();
      await this.changePeriods("range");
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/components/job/driverJob/DriverJob.vue